import React, { useEffect } from "react";
import logo from "../assets/vv_logo.png";
import { RootState } from "../redux/reducer";
// import GoogleLogin from "react-google-login";
import { saveLoggedInData, saveLoggedInToken } from "../common/utils";
import { useNavigate } from "react-router-dom";
import { connect, ConnectedProps } from "react-redux";
import { setLoginSuccessFully } from "../redux/action";
import { useGoogleLogin } from '@react-oauth/google';
import { Button } from "@mui/material";
// import { GoogleLogin } from "react-google-login-component";

type PropsFromRedux = ConnectedProps<typeof connector>;
type LoginProps = PropsFromRedux & {};
const LoginScreen: React.FC<LoginProps> = ({
  setLoginSuccessFully,
  ...rest
}) => {
  // const history = useHistory();
  const navigate = useNavigate();
  
  const scope =
    "https://www.googleapis.com/auth/analytics https://www.googleapis.com/auth/analytics.readonly";

  const login = useGoogleLogin({
    flow: 'implicit',
    scope: scope,
    onSuccess: async (tokenResponse) => {
      console.log("Login Response :::", tokenResponse);
      const tokenObj = {
        access_token: tokenResponse.access_token,
        scope: scope,
        token_type: tokenResponse.token_type || "Bearer",
        expiry_date: tokenResponse.expires_in ? Date.now() + (tokenResponse.expires_in * 1000) : undefined,
      };
      await saveLoggedInData(tokenResponse);
      await saveLoggedInToken(tokenObj);
      await setLoginSuccessFully(tokenObj);
      // history.push("/dashboard");
      navigate('/');
    },
    onError: (errorResponse) => {
      console.error("Login Error :::", errorResponse);
    },
  });

  useEffect(() => {
    // @ts-ignore
    // window.gapi.signin2.render("g-signin2", {
    //   scope: "https://www.googleapis.com/auth/plus.login",
    //   width: 200,
    //   height: 50,
    //   longtitle: true,
    //   theme: "dark",
    //   onsuccess: onSignIn,
    // });
  });

  return (
    <div
      style={{
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <img src={logo} style={{ marginBottom: 100 }} />
      <Button
        variant="contained"
        color="primary"
        onClick={() => login()}
        sx={{
          padding: "10px 24px",
          fontSize: "16px",
          textTransform: "none",
        }}
      >
        Login with Google
      </Button>
      {/*<GoogleButton onClick={() => startLogin()} />*/}
      {/* <GoogleLogin
        clientId="959606247969-ao02vfnhjs8f4i8jrigvl2t17mpfvl0l.apps.googleusercontent.com"
        buttonText="Login with Google"
        onSuccess={responseGoogle}
        onFailure={responseGoogle}
        scope={scope}
        cookiePolicy={"single_host_origin"}
      /> */}

    </div>
  );
};

// export default LoginScreen;
const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
});

const mapDispatch = {};

const connector = connect(mapState, { setLoginSuccessFully });
export default connector(LoginScreen);